<mat-card class="item-card">


    <mat-card-content *ngIf="!isHdr" class="thumbnail" [ngStyle]="thumbObj" (click)="fileDownload($event)">

    </mat-card-content>

    <mat-card-content *ngIf="isHdr" class="thumbnail">
        <app-hdrthumbnail [imageBase]="imageBase" [imageSrc]="imageSrc" [thumbHeight]="thumbHeight"></app-hdrthumbnail>
    </mat-card-content>


    <mat-card-footer class="slide-footer">
        <span class="filesize">{{item.filesize}}</span>
        <mat-card-actions class="actions" [ngClass]="{'show-favorite': (config) }">
            <button mat-icon-button class="download" *ngIf="item.type === 'free' || (config && config.license && config.license != '')" (click)="fileDownload($event)">
                <mat-icon color="primary">file_download</mat-icon>
            </button>
            <button mat-icon-button class="download" *ngIf="item.type == 'paid' && (config.license == '' || config.license == null || !config.license)" (click)="openUpLicense($event)">
                    <mat-icon color="accent">file_download</mat-icon>
                </button>
            <button mat-icon-button (click)="favouriteItem($event)" class="favorite"><mat-icon *ngIf="!favourited" color="primary" >star_border</mat-icon><mat-icon *ngIf="favourited" color="primary">star</mat-icon></button>
        </mat-card-actions>
        <span class="title">{{item.title}} </span>
        <span class="category" *ngIf="item.categoryString">In {{item.categoryString}}</span>
    </mat-card-footer>

</mat-card>



// WEBPACK FOOTER //
// ./src/app/product-carousel/slide/slide.component.html